import React from "react"
// import { createRoot } from 'react-dom/client'
// import stores from '@/stores'
// import { PlatformProvider } from 'platform'

/**
 * 高阶组件用于渲染模态框
 * 它接受一个模态框组件作为输入，并返回一个包含模态框渲染逻辑的函数
 * @param ModalComponent 要渲染的模态框组件类型，它应该接受一个onClose函数作为其属性
 */
export function handleRenderModal<
  IProps extends { onClose?: () => void } = any,
>(ModalComponent: React.ComponentType<IProps>) {
  // 返回一个函数，该函数包含模态框的渲染逻辑
  return () => {
    // 定义控制模态框可见性的状态
    const [visible, setVisible] = React.useState(false)
    // 定义模态框属性的状态，初始为空对象
    const [modalProps, setModalProps] = React.useState<Partial<IProps>>()

    /**
     * 显示模态框的函数
     * 它接受一个包含模态框属性的对象作为参数，并将模态框设为可见状态
     * @param props 可选的模态框属性对象，如果未提供，则使用空对象
     */
    const showModal = (props?: Partial<IProps>) => {
      setModalProps(props || {})
      setVisible(true)
    }

    /**
     * 隐藏模态框的函数
     * 它将模态框设为不可见状态
     */
    const hideModal = () => {
      setVisible(false)
    }

    // 支持updateProps能力
    const updateProps = (newProps: Partial<IProps>) => {
      setModalProps((prevProps) => ({ ...prevProps, ...newProps }))
    }

    // 根据visible状态决定是否渲染模态框组件
    const modalComponent = visible ? (
      <ModalComponent
        {...modalProps}
        open
        // 当模态框关闭时，如果提供了onClose函数，则调用它，并调用hideModal隐藏模态框
        onClose={() => {
          if (modalProps?.onClose) {
            modalProps.onClose()
          }
          hideModal()
        }}
      />
    ) : null

    // 返回模态框组件、显示和隐藏模态框的函数
    return {
      modalComponent,
      showModal,
      hideModal,
      updateProps,
    }
  }
}

// 根元素渲染会导致shopify环境有问题，暂时不使用
// export function rootRenderComponent(component: React.ReactElement) {
//   // 创建一个临时的 div 容器
//   const div = document.createElement('div')
//   document.body.append(div)

//   // 使用 React 18 的 createRoot 方法创建根节点
//   const root = createRoot(div)
//   root.render(
//     <PlatformProvider lang={stores.commonStores.lang}>
//       {component}
//     </PlatformProvider>
//   )

//   return {
//     destroy: () => {
//       // 卸载组件并移除 DOM 容器
//       root.unmount()
//       if (div.parentNode) {
//         div.parentNode.removeChild(div)
//       }
//     },
//     updateProps: (newProps: any) => {
//       // 更新组件的 props
//       root.render(
//         <PlatformProvider lang={stores.commonStores.lang}>
//           {React.cloneElement(component, newProps)}
//         </PlatformProvider>
//       )
//     },
//   }
// }

// 处理根渲染模态框，返回实例支持更新属性方法updateProps和关闭方法
// export function handleRootRenderModal<IProps = any>(ModalComponent) {
//   return (props?: IProps) => {
//     const { value, ...otherProps } = props || ({} as any)
//     // 带过渡动画的关闭弹框
//     const closeModal = (handler) => {
//       handler.updateProps({
//         open: false,
//       })
//       setTimeout(() => {
//         handler.destroy()
//       }, 300)
//     }
//     const handler = rootRenderComponent(
//       <ModalComponent
//         {...otherProps}
//         open={true}
//         onClose={() => {
//           if ((props as any)?.onClose) {
//             ;(props as any).onClose()
//           }
//           closeModal(handler)
//         }}
//       />
//     )
//     return {
//       close: () => closeModal(handler),
//       ...handler,
//     }
//   }
// }
